import BaseXMLGenerator from './xlsx-tableexport-generator.js'
import { buildRowsInBatches } from './build-rows-in-batches.js'
import { dateFormat, weekFormat, hoursFormat } from '@/data/filters/formatter.js'

const HEADERS = [
  '工作日期',
  '星期',
  '部門',
  '人員',
  '專案名稱',
  '任務',
  '工作內容',
  '實際時數',
  '執行狀況',
  '處理說明',
  '獎金實發',
  '獎金日期',
  '狀態',
]

var XMLGenerator = new BaseXMLGenerator()
XMLGenerator.baseGenerate = XMLGenerator.generate

function buildWorkLogRow(vm, data) {
  const row = []
  const task = vm.tasks.find(o => o.ID == data.TaskID) || {}
  const department = vm.departments.find(o => o.ID == task.DepartmentID) || {}
  const user = vm.$store.getters.users.find(o => o.ID == data.UserID) || { Profile: {} }
  const project = vm.$store.getters.projects.find(o => o.ID == task.ProjectID) || {}

  row.push(dateFormat(data.Date))
  row.push(weekFormat(data.Date))
  row.push(department.Name)
  row.push(user.Profile.Name)
  row.push(project.Name)
  row.push(task.Name)
  row.push(data.Content)
  row.push(hoursFormat(data.ActualHours, data.ActualMinutes))
  row.push(data.WorkStatus)
  row.push(data.Report)
  row.push(data.Bonus)
  row.push(dateFormat(data.BonusReleasedAt))
  row.push(data.Status)

  return row
}

XMLGenerator.buildSheetData = async function (vm, datas, onProgress) {
  const rows = await buildRowsInBatches(
    datas,
    data => buildWorkLogRow(vm, data),
    onProgress
  )
  return { headers: HEADERS, rows }
}

XMLGenerator.generate = function (vm, datas) {
  const rows = datas.map(data => buildWorkLogRow(vm, data))
  return this.baseGenerate(rows, HEADERS)
}

export default XMLGenerator
